
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 .667h10A3.333 3.333 0 0117.332 4v10a3.333 3.333 0 01-3.334 3.333H4A3.333 3.333 0 01.666 14V4A3.333 3.333 0 013.999.667zm11.473 14.806c.39-.39.61-.92.61-1.473V4a2.083 2.083 0 00-2.084-2.083H4c-1.15 0-2.083.932-2.083 2.083v10a2.083 2.083 0 002.083 2.083h10c.553 0 1.083-.22 1.473-.61z","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M12.074 6.275a.625.625 0 00-.883 0L9.174 8.29 7.158 6.275a.625.625 0 00-.884.883l2.017 2.017-2.017 2.016a.625.625 0 00.884.884l2.016-2.017 2.017 2.017a.625.625 0 00.442.183.659.659 0 00.441-.183.625.625 0 000-.883l-2.016-2.017 2.016-2.017a.625.625 0 000-.883z","fill":"#7B01B5"}})])
          )
        }
      }
    